const initialState = {
    data: [],
  };
  
const zaleglosciPowiadomieniaReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_ZALEGLOSCI_POWIADOMIENIA':
      return { ...state, data: action.payload };
    default:
      return state;
  }
};

export default zaleglosciPowiadomieniaReducer;